module.exports = __webpack_public_path__ + "static/media/Logo.072de608.svg";